import type { Locale } from '@gelirgider/validators';
import trMessages from './messages/tr.json';
import enMessages from './messages/en.json';
import deMessages from './messages/de.json';
import frMessages from './messages/fr.json';
import nlMessages from './messages/nl.json';
import plMessages from './messages/pl.json';
import itMessages from './messages/it.json';
import esMessages from './messages/es.json';
import svMessages from './messages/sv.json';
import ptMessages from './messages/pt.json';

export type { Locale };

export const SUPPORTED_LOCALES = ['en', 'de', 'fr', 'nl', 'tr', 'pl', 'it', 'es', 'sv', 'pt'] as const;
export const DEFAULT_LOCALE: Locale = 'en';

export type Messages = Record<string, string>;

// PL/IT/ES/SV/PT şu an EN içeriğiyle seed edilmiş — UI çalışır ama henüz
// İngilizce metin görünür. Gerçek çeviriler ileride yerleştirilecek.
const MESSAGES: Record<Locale, Messages> = {
  tr: trMessages,
  en: enMessages,
  de: deMessages,
  fr: frMessages,
  nl: nlMessages,
  pl: plMessages,
  it: itMessages,
  es: esMessages,
  sv: svMessages,
  pt: ptMessages,
};

export function loadMessages(locale: Locale): Promise<Messages> {
  return Promise.resolve(MESSAGES[locale]);
}

export interface FormatCurrencyOptions {
  locale: Locale;
  currency?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

export function formatCurrency(value: number | string, opts: FormatCurrencyOptions): string {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  return new Intl.NumberFormat(localeToBcp47(opts.locale), {
    style: 'currency',
    currency: opts.currency ?? 'EUR',
    minimumFractionDigits: opts.minimumFractionDigits ?? 2,
    maximumFractionDigits: opts.maximumFractionDigits ?? 2,
  }).format(num);
}

export function formatDate(
  value: Date | string,
  opts: { locale: Locale; timezone?: string; format?: 'short' | 'medium' | 'long' | 'full' } = {
    locale: DEFAULT_LOCALE,
  },
): string {
  const date = value instanceof Date ? value : new Date(value);
  return new Intl.DateTimeFormat(localeToBcp47(opts.locale), {
    dateStyle: opts.format ?? 'medium',
    timeZone: opts.timezone,
  }).format(date);
}

function localeToBcp47(locale: Locale): string {
  switch (locale) {
    case 'tr':
      return 'tr-TR';
    case 'en':
      return 'en-US';
    case 'de':
      return 'de-DE';
    case 'fr':
      return 'fr-FR';
    case 'nl':
      return 'nl-NL';
    case 'pl':
      return 'pl-PL';
    case 'it':
      return 'it-IT';
    case 'es':
      return 'es-ES';
    case 'sv':
      return 'sv-SE';
    case 'pt':
      return 'pt-PT';
  }
}
